/**
 * Dashboard
 * @namespace gplans.dashboard.services
 */
(function () {
  'use strict';TimeLine.$inject = ["Profile", "$rootScope", "$q", "ggTypes", "MeasurementSystem"];
  angular.
  module('gplans.dashboard.services').
  factory('TimeLine', TimeLine);

  TimeLine.$inject = ['Profile', '$rootScope', '$q', 'ggTypes', 'MeasurementSystem'];

  function TimeLine(Profile, $rootScope, $q, ggTypes, MeasurementSystem) {

    return {
      get: get };


    function get() {
      return $q.all([
      Profile.getAchievements(),
      Profile.getCheckins(),
      Profile.getWeeklyCoachingAll()]);

    }

  }
})();